import { render, staticRenderFns } from "./InstanceIcon.vue?vue&type=template&id=708b2cbe&"
import script from "./InstanceIcon.vue?vue&type=script&lang=js&"
export * from "./InstanceIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports